<div class="card border-radius-5">
  <div class="relative pt-3">
    <cp-widget-header
      text="Top tip"
      icon="light-bulb"
      variant="light"
      [isAbsolutePosition]="true" />
  </div>

  <div class="py-4">
    <div class="widget-base-layout text-center px-5 pt-2">
      <div class="text-28 bold-800">Almost there! Complete your profile</div>
      <img class="widget-img m-a my-4" src="assets/images/crane.png" />
      <div class="text-14">
        Thanks for signing up to mortgage monitoring! To provide you with the best service, we just
        need to ask you for a few more details. Rest assured, your information is secure with us.
      </div>
      <div class="m-a">
        <button pButton class="p-button p-button-primary" [routerLink]="buttonUrl">
          Complete your profile
        </button>
      </div>
    </div>
  </div>
</div>
